import { useCart } from "@/contexts/CartContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { ShoppingCart, AlertTriangle } from "lucide-react";

export function SellerConflictDialog() {
  const { sellerConflict, resolveConflict } = useCart();
  const { t, dir } = useLanguage();

  return (
    <Dialog open={!!sellerConflict} onOpenChange={(open) => { if (!open) resolveConflict(false); }}>
      <DialogContent dir={dir} className="max-w-sm">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-1">
            <div className="w-10 h-10 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center flex-shrink-0">
              <AlertTriangle className="w-5 h-5 text-amber-600 dark:text-amber-400" />
            </div>
            <DialogTitle className="text-base leading-snug">
              {t("cart.differentSeller")}
            </DialogTitle>
          </div>
          <DialogDescription className="text-sm text-muted-foreground leading-relaxed">
            {t("cart.differentSellerDesc")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button
            className="w-full gap-2"
            onClick={() => resolveConflict(true)}
            data-testid="button-conflict-clear-and-add"
          >
            <ShoppingCart className="w-4 h-4" />
            {t("cart.clearAndAdd")}
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => resolveConflict(false)}
            data-testid="button-conflict-keep-cart"
          >
            {t("cart.keepCart")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
